import { InvoicingAddressFields, InvoicingAddressFormProvider } from 'components/forms/InvoicingAddress'
import { InvoicingAddressPopupController, InvoicingAddressPopupControllerProps } from './InvoicingAddressPopup.component'

import { FC } from 'react'

/**
 * Props for the {@link InvoicingAddressPopup} component.
 */
interface Props extends InvoicingAddressPopupControllerProps {
  /**
   * Optional default form values used to pre-populate fields when editing
   * or initializing a new address with partial data.
   */
  defaultValues?: Partial<InvoicingAddressFields>
}

/**
 * High-level container component for the invoicing address modal.
 *
 * This component wraps the {@link InvoicingAddressPopupController} in a form provider context,
 * ensuring that form state and validation are properly managed throughout the component tree.
 *
 * @component
 * @example
 * ```tsx
 * <InvoicingAddressPopup
 *   isOpen={isModalOpen}
 *   mode="create"
 *   onClose={handleClose}
 *   onSubmit={handleSubmit}
 *   defaultValues={{ companyName: 'Acme Inc.' }}
 * />
 * ```
 */
export const InvoicingAddressPopup: FC<Props> = ({
  query,
  isOpen,
  defaultValues,
  mode = 'create',
  onSubmit,
  onClose,
}) => {
  return (
    <InvoicingAddressFormProvider defaultValues={defaultValues}>
      <InvoicingAddressPopupController
        query={query}
        mode={mode}
        isOpen={isOpen}
        onClose={() => onClose()}
        onSubmit={(values) => onSubmit(values)}
      />
    </InvoicingAddressFormProvider>
  )
}
